import NoticesPage from './NoticesPage';

export default NoticesPage;
